import { useSelector } from "react-redux";
import { get } from "lodash";

// custom hook to retrieve report sidebar selections
export default function useReportSelections() {
  const teacher = useSelector((state) => state.reports.teacher);
  const roster = useSelector(state => state.reports.roster)
  const equating = get(teacher, "equatingSelection", true);
  const benchmark = get(teacher, "selections.benchmark", null);
  const scale = get(teacher, 'selections.scale', null)
  const metric = get(teacher, 'selections.metric', null)
  const reportConfig = get(teacher, 'reportConfig', false);
  const classroom = get(roster, 'ui.selections.classroom')
  const selectedStatePercentileCuts = get(teacher, 'selectedStatePercentileCuts');
  const assessmentTypeFilter =  get(teacher, 'selectedAssessmentTypeFilter', null);
  const { selectedLocale: locale, customBenchmarks } = teacher;
  return { equating, locale, benchmark, customBenchmarks, scale, metric, classroom, selectedStatePercentileCuts, reportConfig, assessmentTypeFilter };
}
